<!--
 * @FilePath: /daren-html-source/src/components/AddPayee/index.vue
 * @Description: 新增收款人弹窗
-->
<template>
  <el-dialog
    :visible.sync="isShow"
    custom-class="addPayee"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">
          <img
            class="icon"
            :src="$utils.getPng('icon-circle-fill')"
            alt=""
            srcset=""
          />
          <span
            >{{
              this.progressList[0].show && !this.progressList[1].show
                ? '设置收款人信息'
                : '设置收款方式'
            }}</span
          >
        </div>
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <!-- 进度条 -->
      <div class="progressBox">
        <div
          class="progress"
          :class="{
            progress: true,
            progressLast: index == 2,
          }"
          v-for="(item, index) in progressList"
          :key="index"
        >
          <div
            :class="{
              num: true,
              numShow: item.show,
            }"
          >
            {{ item.num }}
          </div>
          <div
            :class="{
              name: true,
              nameShow: item.show,
            }"
          >
            {{ item.name }}
          </div>
        </div>
        <div
          :class="{
            line: true,
            lineShow: this.progressList[1].show,
          }"
          class="line"
        ></div>
        <div
          :class="{
            line: true,
            lineShow: this.progressList[2].show,
          }"
          class="line2"
        ></div>
      </div>
      <!-- 内容表单 -->
      <el-form label-position="right" label-width="auto" :model="form">
        <!-- 步骤一 -->
        <div class="content" v-if="!this.progressList[1].show">
          <!-- 国家/地区 -->
          <el-form-item>
            <template slot="label">
              <div class="leftfont">国家/地区<span class="red">*</span></div>
            </template>
            <el-select
              v-model="form.region"
              placeholder="请选择收款地区"
              class="inputOne"
              @change="regionChange"
            >
              <el-option
                v-for="item in address"
                :key="item.region"
                :label="item.name"
                :value="item.region"
              >
                <div class="optionBox">
                  <span>{{ item.name }}</span>
                  <span>{{ item.region }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 姓氏 名字 -->
          <el-form-item class="twoBox">
            <template slot="label">
              <div class="leftfont">姓氏<span class="red">*</span></div>
            </template>
            <el-input
              class="inputTwo"
              v-model="form.last_name"
              placeholder="请输入姓氏"
              clearable
            ></el-input>
            <el-form-item>
              <template slot="label">
                <div class="leftfont">名字<span class="red">*</span></div>
              </template>
              <el-input
                class="inputTwo"
                v-model="form.first_name"
                placeholder="请输入名字"
                clearable
              ></el-input>
            </el-form-item>
          </el-form-item>

          <!-- 身份证号 -->
          <el-form-item v-if="form.region == 'CN'">
            <template slot="label">
              <div class="leftfont">身份证号<span class="red">*</span></div>
            </template>
            <el-input
              v-model="form.account"
              placeholder="请输入身份证号"
              clearable
              class="inputOne"
            >
            </el-input>
          </el-form-item>

          <!-- 手机号 -->
          <el-form-item>
            <template slot="label">
              <div class="leftfont">手机号<span class="red">*</span></div>
            </template>
            <el-input
              v-model="form.phone"
              placeholder="请输入手机号"
              clearable
              class="inputOne padleft"
              :maxlength="form.region == 'CN'?'11':''"
              :class="{
                inputOne: true,
                padOne: form.pucode.length == 2,
                padTwo: form.pucode.length == 3,
                padThree: form.pucode.length > 3,
              }"
            >
              <span
                :class="{
                  areFont: form.phone.length > 0,
                }"
                slot="prefix"
                >{{ form.pucode }}</span
              >
            </el-input>
          </el-form-item>

          <!-- 验证码 -->
          <el-form-item class="threeBox lastItem">
            <template slot="label">
              <div class="leftfont">验证码<span class="red">*</span></div>
            </template>
            <el-input
              class="inputOne"
              v-model="form.qcode"
              placeholder="请输入手机号验证码"
              maxlength="6"
              clearable
            ></el-input>
            <fm-button
              @click.prevent="time == '60' ? toSendcode() : ''"
              :disabled="shouldDisable"
              style="margin-left: 12px; width: 108px"
              size="medium"
              >{{
                time == '60' ? '获取验证码' : '已发送(' + time + 's)'
              }}</fm-button
            >
            <span v-if="time == '60' && isSms && form.pucode == '+86'" class="isSmsclass" @click="toSendcode2()">未收到验证码？</span>
          </el-form-item>
        </div>

        <!-- 内地步骤二 -->
        <div
          class="content"
          v-if="form.region == 'CN' && this.progressList[1].show"
        >
          <!-- 收款方式 -->
          <el-form-item>
            <template slot="label">
              <div class="leftfont">收款方式<span class="red">*</span></div>
            </template>
            <div class="rightBox">
              <div
                :class="{
                  check: true,
                  checkYes: form.payee_type == item.id,
                }"
                v-for="(item, index) in paymentMethod"
                :key="index"
                @click="checkPayMethod(item.id)"
              >
                {{ item.name }}
              </div>
            </div>
          </el-form-item>

          <!-- 支付宝账号 -->
          <el-form-item class="lastItem" v-if="form.payee_type === 0">
            <template slot="label">
              <div class="leftfont">支付宝账号<span class="red">*</span></div>
            </template>
            <div class="iconRight">
              <el-input
                class="inputOne"
                v-model="form.aliacc"
                placeholder="请输入支付宝账号"
                clearable
              ></el-input>
              <div class="iconBox" @click="checkType(1)">
                <svg-btn
                  class="checkSvg"
                  :icon-class="iconTypeOne ? 'icon-check-yes' : 'icon-check-no'"
                />
                <span class="text">是否已在支付宝APP-闪速收款 完成登记？</span>
              </div>
              <div class="iconBox" @click="checkType(2)">
                <svg-btn
                  class="checkSvg"
                  :icon-class="iconTypeTwo ? 'icon-check-yes' : 'icon-check-no'"
                />
                <span class="text"
                  >是否确认收款人姓名和该支付宝账户姓名一致？</span
                >
              </div>
            </div>
          </el-form-item>

          <!-- 银行卡账号 -->
          <el-form-item v-if="form.payee_type == 1">
            <template slot="label">
              <div class="leftfont">银行卡账号<span class="red">*</span></div>
            </template>
            <el-input
              class="inputOne"
              v-model="form.bank_account_number"
              placeholder="请输入银行卡账号（仅支持一类银行卡）"
              clearable
            ></el-input>
          </el-form-item>

          <!-- 城市 -->
          <!-- <el-form-item v-if="form.payee_type == 1">
            <template slot="label">
              <div class="leftfont">城市<span class="red">*</span></div>
            </template>
            <el-input
              class="inputOne"
              v-model="form.city"
              placeholder="请输入城市信息"
              clearable
            ></el-input>
          </el-form-item> -->

          <!-- 地址 -->
          <!-- 中国内地银行卡，暂时隐藏地址一栏 -->
          <!-- <el-form-item v-if="form.payee_type == 1">
            <template slot="label">
              <div class="leftfont">地址</div>
            </template>
            <el-input
              class="inputOne"
              v-model="form.detailed_address"
              placeholder="所在市、县、区、街道信息"
              clearable
            ></el-input>
          </el-form-item> -->

          <!-- 邮政编码 -->
          <!-- <el-form-item v-if="form.payee_type == 1">
            <template slot="label">
              <div class="leftfont">邮编<span class="red">*</span></div>
            </template>
            <el-input
              class="inputOne"
              v-model="form.postal_code"
              placeholder="请输入邮政编码"
              clearable
            ></el-input>
          </el-form-item> -->
        </div>

        <!-- 海外步骤二 -->
        <div
          class="content"
          v-if="form.region != 'CN' && this.progressList[1].show"
        >
          <!-- 收款方式 -->
          <el-form-item>
            <template slot="label">
              <div class="leftfont">收款方式<span class="red">*</span></div>
            </template>
            <div class="rightBox">
              <div
                :class="{
                  check: true,
                  checkYes: form.payee_type == item.id,
                }"
                v-for="(item, index) in hwPaymentMethod"
                :key="index"
                @click="checkPayMethod(item.id)"
              >
                {{ item.name }}
              </div>
            </div>
          </el-form-item>

          <!-- USDT-TRC20 -->
          <el-form-item class="lastItem" v-if="form.payee_type == 3">
            <template slot="label">
              <div class="leftfont">USDT-TRC20<span class="red">*</span></div>
            </template>
            <el-input
              class="inputOne"
              v-model="form.usdt_trc20_address"
              placeholder="仅支持TRC20地址"
              clearable
            ></el-input>
          </el-form-item>

          <!-- 银行卡账号 -->
          <el-form-item v-if="form.payee_type == 2">
            <template slot="label">
              <div class="leftfont">银行卡账号<span class="red">*</span></div>
            </template>
            <el-input
              class="inputOne"
              v-model="form.bank_account_number"
              placeholder="请输入银行卡账号"
              clearable
            ></el-input>
          </el-form-item>

          <!-- 银行名称 -->
          <el-form-item v-if="form.payee_type == 2">
            <template slot="label">
              <div class="leftfont">银行名称<span class="red">*</span></div>
            </template>
            <el-input
              class="inputOne"
              v-model="form.bank_name"
              placeholder="请输入银行名称"
              clearable
            ></el-input>
          </el-form-item>

          <!-- 银行代码 分行代码 -->
          <el-form-item class="twoBox" v-if="form.payee_type == 2">
            <template slot="label">
              <div class="leftfont">银行代码<span class="red">*</span></div>
            </template>
            <el-input
              class="inputTwo"
              v-model="form.bank_code"
              placeholder="请输入"
              clearable
            ></el-input>
            <el-form-item>
              <template slot="label">
                <div class="leftfont">分行代码<span class="red">*</span></div>
              </template>
              <el-input
                class="inputTwo"
                v-model="form.branch_code"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-form-item>

          <!-- SWIFT编码 -->
          <el-form-item v-if="form.payee_type == 2">
            <template slot="label">
              <div class="leftfont">SWIFT编码<span class="red">*</span></div>
            </template>
            <el-input
              class="inputOne"
              v-model="form.swift_code"
              placeholder="请输入SWIFT编码"
              clearable
            ></el-input>
          </el-form-item>

          <!-- 邮政编码 -->
          <el-form-item v-if="form.payee_type == 2">
            <template slot="label">
              <div class="leftfont">邮政编码<span class="red">*</span></div>
            </template>
            <el-input
              class="inputOne"
              v-model="form.postal_code"
              placeholder="请输入邮政编码"
              clearable
            ></el-input>
          </el-form-item>

          <!-- 城市 -->
          <el-form-item v-if="form.payee_type == 2">
            <template slot="label">
              <div class="leftfont">城市<span class="red">*</span></div>
            </template>
            <el-input
              class="inputOne"
              v-model="form.city"
              placeholder="请输入城市信息"
              clearable
            ></el-input>
          </el-form-item>

          <!-- 详细地址 -->
          <el-form-item class="lastItem" v-if="form.payee_type == 2">
            <template slot="label">
              <div class="leftfont">详细地址<span class="red">*</span></div>
            </template>
            <el-input
              class="inputOne"
              v-model="form.detailed_address"
              placeholder="如街道、门牌号、小区、乡镇、村等"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <!-- 步骤一 基本信息 -->
      <div
        class="footerOne"
        v-show="this.progressList[0].show && !this.progressList[1].show"
      >
        <fm-button
          :disabled="disabled"
          @click="nextStep"
          type="primary"
          size="small"
          >下一步</fm-button
        >
      </div>
      <!-- 步骤二 收款方式 -->
      <div class="footerTwo" v-show="this.progressList[1].show">
        <fm-button @click="previousStep" type="info" plain size="small"
          >上一步</fm-button
        >
        <fm-button
          :disabled="disabledTwo"
          @click="confirm"
          type="primary"
          size="small"
          >提 交</fm-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { sendCodeAPI, getRegionCode, updatePayee } from '@/utils/apiList/user'
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    //编辑信息id，添加则是0
    editId: {
      type: Number,
      default: 0,
    },
    //1-编辑 0-新增
    isEdit: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      time: 60,
      timerA: '',
      a1: '',
      form: {
        region: 'CN', //地区代码
        last_name: '', //姓氏
        first_name: '', //名字
        account: '', //身份证号
        aliacc: '', //支付宝账号
        phone: '', //手机号
        qcode: '', //	短信验证码
        pucode: '+86', //区号
        smsid: '', //短信id
        step: 1, //1-仅验证 其他值-提交
        payee_type: 0, //收款人类型 0-支付宝 1-内地银行卡 2-海外银行卡 3-ustd-trc20
        bank_account_number: '', //银行卡账号
        bank_name: '', //银行名称
        bank_code: '', //银行代码
        branch_code: '', //分行代码
        swift_code: '', //SWIFT编码
        postal_code: '', //邮政编码
        city: '', //城市
        detailed_address: '', //详细地址/地址
        usdt_trc20_address: '', //USDT-TRC20地址
      },
      address: [],
      progressList: [
        {
          num: 1,
          name: '基本信息',
          show: true,
        },
        {
          num: 2,
          name: '收款方式',
          show: false,
        },
        {
          num: 3,
          name: '完成登记',
          show: false,
        },
      ],
      paymentMethod: [
        {
          id: 0,
          name: '支付宝',
        },
        {
          id: 1,
          name: '银行卡',
        },
      ],
      hwPaymentMethod: [
        {
          id: 3,
          name: 'USDT',
        },
        {
          id: 2,
          name: '银行卡',
        },
      ],
      iconTypeOne: false,
      iconTypeTwo: false,
      isOne:1,
      isSms: false
    }
  },
  computed: {
    // 获取验证码
    isPhoneValid() {
      const phone = this.form.phone?.toString().trim() || ''
      if (this.form.pucode == '+86' || this.form.region === 'CN') {
        return phone.length == 11 // 中国必须11位
      }
      return phone.length > 0 // 其他国家只需非空
    },
    shouldDisable() {
      return this.time != 60 || !this.isPhoneValid
    },
    //下一步按钮的
    disabled() {
      // 辅助函数：检查值是否为空（去除首尾空格后）
      const isEmpty = value => !value || value.toString().trim().length === 0

      // 1. 必填字段检查（region、last_name、first_name）
      if (
        isEmpty(this.form.region) ||
        isEmpty(this.form.last_name) ||
        isEmpty(this.form.first_name)
      ) {
        return true
      }

      // 2. 只有地区为中国时才检查account
      if (this.form.region === 'CN' && isEmpty(this.form.account)) {
        return true
      }

      // 3. 手机号检查
      const phone = this.form.phone?.toString().trim() || ''
      if (isEmpty(phone)) {
        return true // 所有地区手机号不能为空
      }
      // 仅在中国地区检查手机号是否为11位
      if (this.form.region === 'CN' && phone.length !== 11) {
        return true
      }

      // 4. 检查qcode
      if (isEmpty(this.form.qcode)) {
        return true
      }

      // 所有检查都通过
      return false
    },
    //提交按钮的
    disabledTwo() {
      switch (this.form.payee_type) {
        case 0:
          return (
            !this.form.aliacc?.trim() || // 支付宝账号不能为空
            !this.iconTypeOne || // 需要图标1验证
            !this.iconTypeTwo // 需要图标2验证
          )

        case 1:
          return (
            !this.form.bank_account_number?.trim()  // 银行账号
            // !this.form.postal_code?.trim() || // 邮政编码
            // !this.form.city?.trim() || // 城市
            // !this.form.detailed_address?.trim() // 详细地址
          )

        case 2:
          return (
            !this.form.bank_account_number?.trim() || // 银行账号
            !this.form.bank_name?.trim() || // 银行名称
            !this.form.bank_code?.trim() || // 银行代码
            !this.form.branch_code?.trim() || // 分行代码
            !this.form.swift_code?.trim() || // SWIFT代码
            !this.form.postal_code?.trim() || // 邮政编码
            !this.form.city?.trim() || // 城市
            !this.form.detailed_address?.trim() // 详细地址
          )

        case 3:
          return !this.form.usdt_trc20_address?.trim() // USDT地址

        default:
          return true // 未知类型默认禁用
      }
    },
  },
  created() {
    this.getCode()
  },
  beforeDestroy() {
    this.time = 60
    this.timerA && clearInterval(this.timerA)
  },
  methods: {
    // 获取收款人地区编号
    getCode() {
      getRegionCode().then(res => {
        this.address = res.data.region_list
      })
    },
    regionChange(row) {
      try {
        this.form.pucode = this.address.find(item => item.region == row).pucode
      } catch (e) {
        this.form.pucode = '+86' // 或设置默认值
      }
      this.form.last_name = '' //姓氏
      this.form.first_name = '' //名字
      this.form.account = '' //身份证号
      this.form.aliacc = '' //支付宝账号
      this.form.phone = '' //手机号
      this.form.qcode = '' //短信验证码
      this.form.smsid = '' //短信id
      this.form.step = 1 //1-仅验证 其他值-提交
      this.form.payee_type = 0 //收款人类型 0-支付宝 1-内地银行卡 2-海外银行卡 3-ustd-trc20
      this.form.bank_account_number = '' //银行卡账号
      this.form.bank_name = '' //银行名称
      this.form.bank_code = '' //银行代码
      this.form.branch_code = '' //分行代码
      this.form.swift_code = '' //SWIFT编码
      this.form.postal_code = '' //邮政编码
      this.form.city = '' //城市
      this.form.detailed_address = '' //详细地址/地址
      this.form.usdt_trc20_address = '' //USDT-TRC20地址
      this.iconTypeOne = false,
      this.iconTypeTwo = false,
      this.isOne = 1
      this.time = 60
      this.timerA && clearInterval(this.timerA)
    },
    //下一步
    nextStep: _.debounce(
      async function () {
        if (this.disabled) {
          return
        }
        let res = await updatePayee({
          editId: this.editId,
          isEdit: this.isEdit,
          ...this.form,
        })
        if (res.status == 1) {
          this.progressList[1].show = true
          if (this.isEdit == 0 && this.isOne == 1) {
            if (this.form.region == 'CN') {
              this.form.payee_type = 0
            } else {
              this.form.payee_type = 3
            }
            this.isOne = 2
          }
          this.form.step = 2
        } else {
          this.$toast(res.msg, 2)
        }
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //提交
    confirm: _.debounce(
      async function () {
        if (this.disabledTwo) {
          return
        }
        let res = await updatePayee({
          editId: this.editId,
          isEdit: this.isEdit,
          ...this.form,
        })
        if (res.status == 1) {
          this.$toast(res.msg, 1)
          this.$emit('confirm')
          if (this.$route.name == 'homepage' || this.$route.name == 'account') {
            // this.$parent.userInfo.is_income_account = 1
            // this.$parent.openDaren()
          } else {
            this.$parent.getPayeeList()
          }
          this.handleClose()
          this.$store.commit('setShowComplete', true)
        } else {
          this.$toast(res.msg, 2)
        }
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //上一步
    previousStep() {
      this.form.step = 1
      this.progressList[1].show = false
    },
    //切换支付方式
    checkPayMethod(id) {
      this.form.payee_type = id
    },
    checkType(row) {
      if (row === 1) {
        this.iconTypeOne = !this.iconTypeOne
      } else {
        this.iconTypeTwo = !this.iconTypeTwo
      }
    },
    handleClose() {
      this.isSms = false
      this.$parent.showAddpayFlag = false
      this.time = 60
      this.timerA && clearInterval(this.timerA)
      this.$emit('handleClose')
      this.progressList = [
        {
          num: 1,
          name: '基本信息',
          show: true,
        },
        {
          num: 2,
          name: '收款方式',
          show: false,
        },
        {
          num: 3,
          name: '完成登记',
          show: false,
        },
      ]
      this.form = {
          region: 'CN', //地区代码
          last_name: '', //姓氏
          first_name: '', //名字
          account: '', //身份证号
          aliacc: '', //支付宝账号
          phone: '', //手机号
          qcode: '', //	短信验证码
          pucode: '+86', //区号
          smsid: '', //短信id
          step: 1, //1-仅验证 其他值-提交
          payee_type: 0, //收款人类型 0-支付宝 1-内地银行卡 2-海外银行卡 3-ustd-trc20
          bank_account_number: '', //银行卡账号
          bank_name: '', //银行名称
          bank_code: '', //银行代码
          branch_code: '', //分行代码
          swift_code: '', //SWIFT编码
          postal_code: '', //邮政编码
          city: '', //城市
          detailed_address: '', //详细地址/地址
          usdt_trc20_address: '', //USDT-TRC20地址
        }
    },
    minute: function () {
      this.time = this.time - 1
      if (this.time == 0) {
        this.time = 60
        clearInterval(this.timerA)
      }
    },
    toSendcode2: _.debounce(
      function (captcha_verify, validate = {}) {
        return new Promise(resolve => {
          if (validate == 'close') {
            return
          }
          if (this.form.region === 'CN' && this.form.phone.length != 11) {
            return
          }
          if (this.form.phone.toString().trim().length === 0) {
            return
          }
          if (this.time != 60) {
            return
          }
          var reg_tel =
            /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
          if (this.form.region === 'CN' && !reg_tel.test(this.form.phone)) {
            this.$toast('请正确输入手机号', 3)
            return
          }
          this.timerA && clearInterval(this.timerA)
          sendCodeAPI({
            pcode: this.form.pucode,
            phone: this.form.phone,
            origin: 1, //传1-新增或编辑收款人时发送验证码
            captcha_verify: captcha_verify || '',
            lot_number: validate?.lot_number || '',
            captcha_output: validate?.captcha_output || '',
            pass_token: validate?.pass_token || '',
            gen_time: validate?.gen_time || '',
            sms_type: 2
          })
            .then(res => {
              if (res.status == 1) {
                resolve({
                  result: true,
                  validate: true,
                })
                this.form.smsid = res.data.msgid
                this.timerA = setInterval(() => {
                  this.minute()
                }, 1000)
                this.$toast(res.msg, 1)

                this.$toast(res.msg, 1)
              } else if (res.status == 90001) {
                resolve({
                  result: false,
                  validate: false,
                })
                this.$toast(res.msg, 2)
                this.$AliCode.handleOpen(this.toSendcode2)
              } else if (res.status == 90002) {
                this.$utils.initgt4(
                  "460bf232a926f297be83b8622a637c21",
                  this.toSendcode2
                );
              } else {
                resolve({
                  result: true,
                  validate: true,
                })
                this.$toast(res.msg, 2)
              }
            })
            .catch(err => {})
        })
      },
      1000,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    toSendcode: _.debounce(
      function (captcha_verify, validate = {}) {
        return new Promise(resolve => {
          if (validate == 'close') {
            return
          }
          if (this.form.region === 'CN' && this.form.phone.length != 11) {
            return
          }
          if (this.form.phone.toString().trim().length === 0) {
            return
          }
          if (this.time != 60) {
            return
          }
          var reg_tel =
            /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
          if (this.form.region === 'CN' && !reg_tel.test(this.form.phone)) {
            this.$toast('请正确输入手机号', 3)
            return
          }
          this.timerA && clearInterval(this.timerA)
          sendCodeAPI({
            pcode: this.form.pucode,
            phone: this.form.phone,
            origin: 1, //传1-新增或编辑收款人时发送验证码
            captcha_verify: captcha_verify || '',
            lot_number: validate?.lot_number || '',
            captcha_output: validate?.captcha_output || '',
            pass_token: validate?.pass_token || '',
            gen_time: validate?.gen_time || '',
            sms_type: 0
          })
            .then(res => {
              if (res.status == 1) {
                resolve({
                  result: true,
                  validate: true,
                })
                this.form.smsid = res.data.msgid
                this.timerA = setInterval(() => {
                  this.minute()
                  this.isSms = true
                }, 1000)
                this.$toast(res.msg, 1)

                this.$toast(res.msg, 1)
              } else if (res.status == 90001) {
                resolve({
                  result: false,
                  validate: false,
                })
                this.$toast(res.msg, 2)
                this.$AliCode.handleOpen(this.toSendcode)
              } else if (res.status == 90002) {
                this.$utils.initgt4(
                  "460bf232a926f297be83b8622a637c21",
                  this.toSendcode
                );
              } else {
                resolve({
                  result: true,
                  validate: true,
                })
                this.$toast(res.msg, 2)
              }
            })
            .catch(err => {})
        })
      },
      1000,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    resetTime() {
      this.time = 60
      this.timerA && clearInterval(this.timerA)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .addPayee {
  width: 560px;
  .el-dialog__body {
    padding: 20px 32px 32px 24px;
  }
  //进度条
  .progressBox {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 32px;
    position: relative;
    margin-bottom: 32px;
    .progress {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-right: 124px;
      .num {
        padding: 1px 6px;
        background: #e5e5e5;
        color: #8a8b92;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 8px;
      }
      .numShow {
        background: #7e72f6 !important;
        color: #ffffff !important;
      }
      .name {
        font-size: 13px;
        line-height: 18px;
        color: rgba(44, 44, 44, 0.8);
        white-space: nowrap;
      }
      .nameShow {
        color: #2c2c2c;
        font-weight: 500;
      }
    }
    .progressLast {
      margin-right: 0 !important;
    }
    .line {
      width: 140px;
      height: 1px;
      background: #e5e5e5;
      position: absolute;
      left: 94px;
      top: 10px;
    }
    .line2 {
      width: 140px;
      height: 1px;
      background: #e5e5e5;
      position: absolute;
      left: 270px;
      top: 10px;
    }
    .lineShow {
      background: #7e72f6 !important;
    }
  }
  //主题内容
  .content {
    // padding-left: 25px;
    .el-form-item {
      margin-bottom: 24px;
      .el-form-item__label {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        white-space: nowrap;
        padding-right: 20px;
      }
      .el-form-item__content {
        .inputOne {
          width: 100%;
        }
        .inputTwo {
          width: 132px;
          height: 40px;
        }
        .el-input__prefix {
          color: #bdbdbe;
          left: 12px;
        }
        .areFont {
          color: #2c2c2c;
        }
        .padOne {
          .el-input__inner {
            padding-left: 36px;
          }
        }
        .padTwo {
          .el-input__inner {
            padding-left: 46px;
          }
        }
        .padThree {
          .el-input__inner {
            padding-left: 55px;
          }
        }
        .btnSend {
          font-weight: 500;
          font-size: 12px;
          color: #7e72f6;
          line-height: 20px;
          margin-left: 16px;
          cursor: pointer;
        }
      }
    }
    .lastItem {
      margin-bottom: 0 !important;
    }
    .twoBox {
      margin-bottom: 0 !important;
      .el-form-item__content {
        display: flex;
        justify-content: space-between;
        &::before {
          display: none;
        }
        &::after {
          display: none;
        }
      }
    }
    .threeBox {
      margin-bottom: 0 !important;
      position: relative;
      .el-form-item__content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &::before {
          display: none;
        }
        &::after {
          display: none;
        }
      }

      .isSmsclass{
        position: absolute;
        bottom: -22px;
        height: 20px;
        line-height: 20px;
        cursor: pointer;
        font-size: 12px !important;
        @include font_style(16px, 400, #F53F3F);
      }
    }
    .rightBox {
      display: flex;
      background: #f6f6f6;
      border-radius: 8px;
      // border: 1px solid #f6f6f6;
      font-weight: 400;
      font-size: 13px;
      color: #8a8b92;
      line-height: 18px;
      width: 304px;
      height: 40px;
      cursor: pointer;
      .check {
        width: 152px;
        height: 40px;
        // box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          color: #2c2c2c;
        }
      }
      .checkYes {
        background: #7e72f6;
        font-weight: 500;
        font-size: 13px;
        color: #ffffff !important;
        line-height: 18px;
        box-shadow: 0 8px 20px 0 rgba(0, 0, 0, .06);
      }
    }
    .iconRight {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    .iconBox {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 12px;
      cursor: pointer;
      .checkSvg {
        width: 16px;
        height: 16px;
      }
      .text {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 22px;
        text-align: left;
        margin-left: 8px;
      }
    }
    .red {
      color: #f53f3f !important;
    }
  }
  //步骤一按钮
  .footerOne {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 32px;
    .fm-button {
      padding: 8px 39px;
      height: 40px;
    }
  }
  //步骤2按钮
  .footerTwo {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 32px;
    .fm-button-info {
      margin-right: 16px;
    }
    .fm-button {
      width: 120px;
      height: 40px;
    }
  }
}
</style>
<style lang="scss">
.optionBox {
  display: flex;
  justify-content: space-between;
}
</style>
